// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import axios from "axios";
import { stringify } from "query-string";

import * as constants from "../../constants";
import { AXIOS_DEFAULT_OPTIONS, AXIOS_DEFAULT_OPTIONS_HEADERS } from "../";
import { getConfig } from "../../reducers/portalConfig";
import { getValidationErrors } from "../../utils";

const init = (dispatch, isLoading = true) =>
  dispatch({
    type: constants.APP_RESET,
    isLoading,
  });

const buildQueryParams = (params) => {
  let queryString = stringify(params, true);
  queryString = queryString ? `?${queryString}` : "";
  return queryString;
};

export const fetchCustomFields = (params = {}) =>
  async (dispatch, getState) => {

    const defaultParams = { size: 24, page: 0 };

    const queryParams = buildQueryParams({
      ...defaultParams,
      ...params,
    });

    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields${queryParams}`;
    init(dispatch, true);
    await axios
      .get(url, AXIOS_DEFAULT_OPTIONS)
      .then((response) => {
        dispatch({
          type: constants.FETCH_SETTINGS_CUSTOM_FIELDS_SUCCESS,
          isLoading: false,
          payload: response.data ? response.data : [],
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.FETCH_SETTINGS_CUSTOM_FIELDS_ERROR,
          payload: getValidationErrors(error),
        }),
      );
};

export const deleteCustomFields = ({ uuid }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    init(dispatch, true);
    dispatch({ type : constants.CUSTOM_FIELDS_DELETE_REQUEST })
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields/${uuid}`;
    await axios.delete(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.CUSTOM_FIELDS_DELETE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.CUSTOM_FIELDS_DELETE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchCustomFieldsOptions = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/admin/resourceValues?resources=entityTypes,customFieldTypes`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.FETCH_CUSTOM_FIELDS_OPTIONS_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.FETCH_CUSTOM_FIELDS_OPTIONS_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const addCustomField = (payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.ADD_CUSTOM_FIELDS_REQUEST,
      loading: true,
    })

    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields`;
    await axios.post(url, payload, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then(() =>
        dispatch({
          type: constants.ADD_CUSTOM_FIELDS_SUCCESS,
          payload: true,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.ADD_CUSTOM_FIELDS_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchCustomFieldNameUnique = ({ uuid, name }) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const params = buildQueryParams({
      ...(uuid && { uuid }),
      ...(name && { name }),
    })
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields/unique-name${params}`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.CUSTOM_FIELDS_NAME_UNIQUE_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.CUSTOM_FIELDS_NAME_UNIQUE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const fetchCustomFieldDetails = (uuid) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields/${uuid}`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.FETCH_CUSTOM_FIELDS_EDIT_SUCCESS,
          payload: response.data,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.FETCH_CUSTOM_FIELDS_EDIT_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };

export const updateCustomField = (uuid, payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.CUSTOM_FIELDS_UPDATE_REQUEST,
      loading: true,
    })

    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/api-management/1.0/custom-fields/${uuid}`;
    await axios.put(url, payload, AXIOS_DEFAULT_OPTIONS_HEADERS)
      .then(() =>
        dispatch({
          type: constants.CUSTOM_FIELDS_UPDATE_SUCCESS,
          payload: true,
        }),
      )
      .catch(error =>
        dispatch({
          type: constants.CUSTOM_FIELDS_UPDATE_ERROR,
          payload: getValidationErrors(error),
        }),
      );
  };
